import { ref } from 'vue';
import { handleRequest } from '@/composables';
import { RequestMethodEnum } from '@/types/enums/RequestMethodEnum';

export function useIntegrators() {
    const integrators = ref<{ id: number; name: string }[]>([]);
    const isIntegratorsLoading = ref(false);

    const fetchIntegrators = async () => {
        isIntegratorsLoading.value = true;
        await handleRequest({
            method: RequestMethodEnum.Get,
            endpoint: '/integrators',
            onSuccess: response => {
                integrators.value = response.data.data;
            },
        });
        isIntegratorsLoading.value = false;
    };

    return { integrators, isIntegratorsLoading, fetchIntegrators };
}
